import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import classNames from 'classnames';
import s from './EditonSwitch.scss';

class EditonSwitch extends React.Component {
  render() {
    const { colorTheme, doNotshowEditionText } = this.props;
    const theme = this.props.colorTheme ? s[colorTheme] : '';
    const defaultCountry = this.props.editionSwitch.editions.filter(
      item => item.default === true,
    )[0];
    return (
      <div
        className={`${s[`${this.props.editionSwitch.theme}`] || ''}
         ${theme}
         ${s['edition-box']}`}
      >
        <>
          {!doNotshowEditionText && <span className={s.text}>Edition</span>}
          <div className={`${s['text-display']} ${s[`${defaultCountry.id}`]}`}>
            <span>{defaultCountry.label}</span>
            <ul>
              {this.props.editionSwitch.editions.map(item => (
                <li
                  className={classNames({
                    [`${s.us}`]: item.id === `us`,
                    [`${s.india}`]: item.id === `in`,
                  })}
                  key={item.id}
                >
                  <Link
                    to={item.link}
                    target={item.openInNewTab ? '_blank' : ''}
                    data-newga={`switch_country#switch_country_${item.id}`}
                    aria-label={item.label}
                    ga4Data={[
                      {
                        event: 'user_click',
                        type: 'header',
                        category: `switch_country_${item.id}`,
                      },
                    ]}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </>
        {/* {showTOIPlus && */}
        {this.props.showToiPlusEntryPoints && (
          <div className={s.toiplus}>
            Go to<Link to="/toi-plus">
              <i />
            </Link>
          </div>
        )}
      </div>
    );
  }
}

EditonSwitch.propTypes = {
  editionSwitch: PropTypes.shape({
    editions: PropTypes.instanceOf(Array),
    theme: PropTypes.string,
  }).isRequired,
  colorTheme: PropTypes.string,
  // showTOIPlus: PropTypes.bool,
  // isPrimeUser: PropTypes.bool,
  showToiPlusEntryPoints: PropTypes.bool,
  doNotshowEditionText: PropTypes.bool,
};
EditonSwitch.defaultProps = {
  colorTheme: '',
  // showTOIPlus: false,
  // isPrimeUser: true,
  showToiPlusEntryPoints: false,
  doNotshowEditionText: false,
};

export default EditonSwitch;
